/* tslint:disable */

declare var Object: any;
export interface TtadondutydeclarationdtlInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "destinationCode": string;
  "startdate": Date;
  "enddate": Date;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  ttadondutydeclarationdtlAtd?: any[];
  ttadondutydeclarationdtlItem?: any[];
  rel_destination?: any;
}

export class Ttadondutydeclarationdtl implements TtadondutydeclarationdtlInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "destinationCode": string;
  "startdate": Date;
  "enddate": Date;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  ttadondutydeclarationdtlAtd: any[];
  ttadondutydeclarationdtlItem: any[];
  rel_destination: any;
  constructor(data?: TtadondutydeclarationdtlInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadondutydeclarationdtl`.
   */
  public static getModelName() {
    return "Ttadondutydeclarationdtl";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadondutydeclarationdtl for dynamic purposes.
  **/
  public static factory(data: TtadondutydeclarationdtlInterface): Ttadondutydeclarationdtl{
    return new Ttadondutydeclarationdtl(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadondutydeclarationdtl',
      plural: 'Ttadondutydeclarationdtls',
      path: 'Ttadondutydeclarationdtls',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "destinationNo": {
          name: 'destinationNo',
          type: 'number'
        },
        "destinationCode": {
          name: 'destinationCode',
          type: 'string'
        },
        "startdate": {
          name: 'startdate',
          type: 'Date'
        },
        "enddate": {
          name: 'enddate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
        ttadondutydeclarationdtlAtd: {
          name: 'ttadondutydeclarationdtlAtd',
          type: 'any[]',
          model: ''
        },
        ttadondutydeclarationdtlItem: {
          name: 'ttadondutydeclarationdtlItem',
          type: 'any[]',
          model: ''
        },
        rel_destination: {
          name: 'rel_destination',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadondutydeclarationdtl.ts